module.exports = __webpack_public_path__ + "static/img/centerbanner.c43fda75.gif";